import { createRequestActions } from "common/helpers/action";

export const initUsersAdd = createRequestActions("USERS.ADD.INIT");
export const sendUsersAdd = createRequestActions("USERS.ADD.SEND");
